const variants = {
  rectangle: {
    width: "auto",
    borderRadius: 4,
    paddingX: 2,
    paddingY: 1,
    lineHeight: 1,
  },
  circle: {
    width: 18,
    height: 18,
    borderRadius: "50%",
    paddingX: 0,
    paddingY: 0,
    lineHeight: 1,
  },
};

export default variants;
